import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { alpha, Typography } from "@mui/material";

import { useTopLevelDropTarget } from "./table/useGroupDrag";

const useStyles = makeStyles()((theme) => ({
    strip: {
        position: "absolute",
        inset: 0,
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
        border: `2px dashed ${theme.palette.emteria.primary}`,
        borderRadius: theme.spacing(2),
        backgroundColor: theme.palette.emteria.background.paper,
        backgroundImage: `linear-gradient(${alpha(theme.palette.emteria.primary, 0.08)}, ${alpha(theme.palette.emteria.primary, 0.08)})`,
        color: theme.palette.emteria.primary,
    },
    active: {
        borderStyle: "solid",
        backgroundImage: `linear-gradient(${alpha(theme.palette.emteria.primary, 0.2)}, ${alpha(theme.palette.emteria.primary, 0.2)})`,
    },
}));

/**
 * Laid over the search row while a subgroup is dragged; the page makes that row tall enough to be an easy target.
 */
export const GroupTopLevelDropStrip = () => {
    const { t } = useTranslation(["pages"]);
    const { classes, cx } = useStyles();
    const [strip, setStrip] = React.useState<HTMLDivElement | null>(null);
    const isActive = useTopLevelDropTarget(strip);

    return (
        <div ref={setStrip} className={cx(classes.strip, isActive && classes.active)}>
            <i className="fa-solid fa-arrow-up" />
            <Typography component="span">{t("pages:groupPage.dragAndDrop.dropToTopLevel")}</Typography>
        </div>
    );
};
